import { Asterisk } from "lucide-react";

export default function Marquee({ items, className = "", itemClassName = "" }) {
    return (
        <div
            data-testid="marquee-strip"
            className={`overflow-hidden border-y border-ink/5 bg-white ${className}`}
        >
            <div className="flex w-max animate-marquee py-5">
                {[0, 1].map((copy) => (
                    <div
                        key={copy}
                        aria-hidden={copy === 1}
                        className="flex shrink-0 items-center"
                    >
                        {items.map((item, i) => (
                            <span key={i} className="flex items-center">
                                <span
                                    className={`whitespace-nowrap px-8 text-sm font-semibold uppercase tracking-[0.3em] ${itemClassName}`}
                                >
                                    {item}
                                </span>
                                <Asterisk className="h-4 w-4 shrink-0 text-accent/40" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}